import React from 'react';
import { connect } from 'react-redux';
import { callService, formatPhone, formatDate } from '../tools';

import ConfidencialidadForm from '../contrato/confidencialidad.frm';

const mapState = (state) => {
    return {
        loading: state.global.loading,
		hashOne: state.registroAF.hashOne,
		hashTwo: state.registroAF.hashTwo,
        apaterno: state.registroAF.apaterno,
        amaterno: state.registroAF.amaterno,
        nombres: state.registroAF.nombres,
        email: state.registroAF.email,
		fechaNacimientoDate: state.registroAF.fechaNacimientoDate,
		genero: state.registroAF.genero,
		ladaCelular: state.registroAF.ladaCelular,
		telCelular: state.registroAF.telCelular,
		rfc: state.registroAF.rfc,
        poliza: state.registroAF.poliza,
		password: state.registroAF.password,
        pregunta1: state.registroAF.pregunta1,
        pregunta2: state.registroAF.pregunta2,
        respuesta1: state.registroAF.respuesta1,
        respuesta2: state.registroAF.respuesta2,
        mediosElectronicos: state.registroAF.mediosElectronicos,
        datosPersonales: state.registroAF.datosPersonales
	};
};

const mapDispatch = (dispatch,ownProps) => {
    return {
        loader: (show) => {
            dispatch({"type": "LOADER", "show": show});
        },
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje" : sMensaje });
		},
		alertaCode: (sCode) => {
			dispatch({ "type": "MODAL_ALERT_CODE_SHOW", "codigo" : sCode });
		},		
        siguientePaso: () => {
            dispatch({ "type": "REGISTRO_FAMILIAR_PASO", "paso": 5 });
        },
		registrarDatos(bAccept) {
		    dispatch({ "type": "REGISTRO_FAMILIAR_CONTRATO_DP", "datosPersonales": bAccept })
        }
    }
}

class Confidencialidad extends React.Component{

    submit = (data) => {
        let $this = this;
        $this.props.registrarDatos(data.acepto);
        
        $this.props.loader(true);
        let llamaServicio = new callService({
            service: 'accesoFamiliar.registroInvitacion',
            secure: true,
            data: {
                hashOne: this.props.hashOne,
                hashTwo: this.props.hashTwo,
                apaterno: this.props.apaterno,
                amaterno: this.props.amaterno,
                nombres: this.props.nombres,
                email: this.props.email,
                fechaNacimiento: formatDate(this.props.fechaNacimientoDate),
                genero: this.props.genero,
                ladaCelular: formatPhone(this.props.ladaCelular),
                telCelular: this.props.telCelular,
                rfc: this.props.rfc,
                poliza: this.props.poliza,
                password: this.props.password,
                pregunta1: this.props.pregunta1,
                pregunta2: this.props.pregunta2,
                respuesta1: this.props.respuesta1,
                respuesta2: this.props.respuesta2,
                mediosElectronicos: this.props.mediosElectronicos,
                datosPersonales: data.acepto
            }
        }).execute().then((respuesta) => {
            console.log("Respuesta", respuesta);
            $this.props.loader(false);
            
            if(respuesta.aceptacionInvitado.banExito) {
                $this.props.siguientePaso();
            }
        }).catch((error) => {
            console.log("Error", error);
            $this.props.loader(false);
            if(error.message.codigoError) {
                $this.props.alertaCode(error.message.codigoError);    
            } else {
                $this.props.alerta(error.message.mensaje);
            }
        });
    }

	render() {
		return <ConfidencialidadForm onSubmit={this.submit} />
	}    
}

export default connect(mapState, mapDispatch)(Confidencialidad);

/*
"hashOne": "3119b1d1c1e03f37970706f09de66e58b5b251eddaa2de169219327e",
"hashTwo": "361cb7d9c9e0342c8d7c44fdc3b7",
"apaterno": "hernandez",
"amaterno": "cortes",
"nombres": "juan",
"email": "pavel2@gmail.com",
"fechaNacimiento": "19650722",
"ladaCelular": "55",
"telCelular": "18450779",
"rfc": "",
"poliza": "",
"password": "rest2468",
"pregunta1": "PSC01",
"pregunta2": "PSC08",
"respuesta1": "wer",
"respuesta2": "sdfg",
"mediosElectronicos": true,
"datosPersonales": true
*/


// WEBPACK FOOTER //
// ./src/registro-familiar/contrato-datos.cmpt.js